import { createAction, props } from '@ngrx/store';
import { ListSearch, ModuleV1Read } from '@ca/core/models';
import {
    MyModulesDeleteError,
    MyModulesLoadingError,
    MyModulesPublishError,
    MyModulesTotalCountLoadingError,
    MyModulesUpdateError,
} from './../../my-modules.reducer';

const prefix = '[MyModules]';

export const loadMyModules = createAction(`${prefix} Load MyModules`, props<{ query?: ListSearch | undefined; isReloadEnforced?: boolean }>());
export const loadMyModulesSuccess = createAction(
    `${prefix} Load MyModules Success`,
    props<{ modules: ModuleV1Read[]; filteredTotalCount: number; query: ListSearch | undefined }>(),
);
export const loadMyModulesCacheSuccess = createAction(
    `${prefix} Load MyModules From Cache Success`,
    props<{ modules: ModuleV1Read[]; filteredTotalCount: number; query: ListSearch | undefined }>(),
);
export const loadMyModulesFailure = createAction(`${prefix} Load MyModules Failure`, props<{ error: MyModulesLoadingError }>());
export const loadMyModulesTotalCount = createAction(`${prefix} Load MyModules Total Count`);
export const loadMyModulesTotalCountSuccess = createAction(`${prefix} Load MyModules Total Count Success`, props<{ totalCount: number }>());
export const loadMyModulesTotalCountFailure = createAction(`${prefix} Load MyModules Total Count Failure`, props<{ error: MyModulesTotalCountLoadingError }>());
export const deleteMyModuleSuccess = createAction(`${prefix} Delete MyModule Success`);
export const deleteMyModuleFailure = createAction(`${prefix} Delete MyModule Failure`, props<{ error: MyModulesDeleteError }>());
export const publishMyModuleSuccess = createAction(`${prefix} Publish MyModule Success`, props<{ module: ModuleV1Read }>());
export const publishMyModuleFailure = createAction(`${prefix} Publish MyModule Failure`, props<{ error: MyModulesPublishError }>());
export const updateMyModuleFailure = createAction(`${prefix} Update MyModule Failure`, props<{ error: MyModulesUpdateError }>());
export const updateMyModuleSuccess = createAction(`${prefix} Update MyModule Success`, props<{ module: ModuleV1Read }>());
